module.exports = __webpack_public_path__ + "img/nav-Admin-Gray.efad72c2.png";